import AVdxbIcon from './index.vue';

AVdxbIcon.install = app => {
  app.component(AVdxbIcon.name, AVdxbIcon);
};

export default AVdxbIcon;
